function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M70.9456 1L42.562 22L47.8102 9.61005L70.9456 1Z",
  fill: "#E2761B",
  stroke: "#E2761B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.41356 1.41846L33.8017 22.5748L28.7692 10.0112L5.41356 1.41846ZM61.1839 49.9984L53.5616 61.5121L69.8699 65.9362L74.5581 50.2532L61.1839 49.9984ZM2.39404 50.2532L7.05339 65.9362L23.3617 61.5121L15.7394 49.9978L2.39404 50.2532Z",
  fill: "#E4761B",
  stroke: "#E4761B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.441 30.5436L17.897 37.3216L34.0893 38.0302L33.5143 20.8731L22.441 30.5436ZM54.4531 30.5436L43.2362 20.6741L42.8618 38.0297L59.0265 37.321L54.4531 30.5436ZM23.3615 61.5121L33.0828 56.8326L24.6841 50.3669L23.3615 61.5121ZM43.8112 56.8326L53.5614 61.5121L52.2099 50.3669L43.8112 56.8326Z",
  fill: "#E4761B",
  stroke: "#E4761B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M53.4652 61.6502L43.7776 57.1147L44.5496 63.1897L44.4636 65.7457L53.4652 61.6502ZM23.459 61.6502L32.4606 65.7457L32.4033 63.1892L33.118 57.1147L23.459 61.6502Z",
  fill: "#D7C1B3",
  stroke: "#D7C1B3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.5191 46L23.3013 43.615L29.1008 41L31.5191 46ZM43.4378 46L45.8566 41L51.6848 43.615L43.4378 46Z",
  fill: "#233447",
  stroke: "#233447"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9519 61.5738L24.3233 50.0389L15.3784 50.2947L22.9519 61.5738ZM51.5868 50.0395L52.9582 61.5738L60.5317 50.2947L51.5868 50.0395ZM58.3883 37.3401L42.3272 38.05L43.8132 46.2616L46.1853 41.318L51.9008 43.9035L58.3883 37.3401ZM24.0374 43.9029L29.7534 41.3174L32.0963 46.261L33.611 38.05L17.5224 37.3401L24.0374 43.9029Z",
  fill: "#CD6116",
  stroke: "#CD6116"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7954 37.3369L24.546 50.2788L24.3177 43.8361L17.7954 37.3369ZM52.2073 43.8361L51.9204 50.2788L58.7003 37.3369L52.2073 43.8361ZM33.8997 38.0399L32.3835 46.1713L34.272 55.7652L34.701 43.1331L33.8997 38.0399ZM42.6247 38.0399L41.852 43.1043L42.195 55.7652L44.1115 46.1713L42.6247 38.0399Z",
  fill: "#E4751F",
  stroke: "#E4751F"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M43.4467 46.3612L41.4962 56.0616L42.8939 57L51.3941 50.5143L51.6848 44L43.4467 46.3612ZM23.3013 44L23.5342 50.5143L32.0356 57L33.4327 56.0616L31.5108 46.3612L23.3013 44Z",
  fill: "#F6851B",
  stroke: "#F6851B"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M43.5755 66.2572L43.662 63.5997L42.9383 62.9712H32.0188L31.3526 63.5997L31.4106 66.2572L22.2876 62L25.4734 64.5715L31.9322 69H43.0249L49.5127 64.5715L52.6986 62L43.5755 66.2572Z",
  fill: "#C0AD9E",
  stroke: "#C0AD9E"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M42.8029 56.9091L41.4288 56H33.501L32.1269 56.9091L31.4111 63L32.0695 62.3932H42.8603L43.5755 62.9994L42.8029 56.9091Z",
  fill: "#161616",
  stroke: "#161616"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M72.1065 23.5772L74.5456 12.0881L70.9008 1.41553L43.2929 21.5216L53.9113 30.3357L68.921 34.6439L72.2498 30.8428L70.815 29.8286L73.1114 27.773L71.3318 26.4217L73.6276 24.7038L72.1065 23.5772ZM1.36426 12.0881L3.80332 23.5772L2.25343 24.7038L4.54978 26.4211L2.79904 27.773L5.0948 29.8286L3.66002 30.8428L6.96065 34.6439L21.9697 30.3357L32.5881 21.5216L4.97969 1.41553L1.36426 12.0881Z",
  fill: "#763D16",
  stroke: "#763D16"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M68.9383 34.933L53.9352 30.5835L58.4966 37.3783L51.6974 50.456L60.6475 50.342H73.9863L68.9383 34.933ZM22.0078 30.5835L7.00471 34.933L2.01367 50.342H15.3237L24.245 50.456L17.4752 37.3783L22.0078 30.5835ZM42.3752 38.0887L43.3215 21.6849L47.6815 10H28.3185L32.6215 21.6849L33.6253 38.0887L33.9699 43.2632L33.9987 56H41.9443L42.0018 43.2632L42.3752 38.0887Z",
  fill: "#F6851B",
  stroke: "#F6851B"
});

var SvgMetamask = function SvgMetamask(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 70,
    viewBox: "0 0 76 70",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMetamask, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/metamask.0b71b9d4.svg";
export { ForwardRef as ReactComponent };